export enum DateSelectionType {
  Immediate = 'I',
  Future = 'F'
}
